<template>
  <div class="iq-footer">
    <footer class="px-0 py-2">
      <div class="d-flex flex-column flex-md-row justify-content-md-between px-3">
        <div class="footer-powered-by">
          <img
            src="@/assets/images/logo/CIT-logo.png"
            alt="CIT-logo"
            class="cit-logo"
          >
          Powered by NC CIT Department
        </div>
        <div>
          <span class="font-weight-bold">
            OSAS Landing Page System
          </span>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
// import Vue from 'vue'

export default {
  name: 'Footer',

  computed: {
    appVersion () {
      return process.env.VUE_APP_VERSION
    }
  }
}
</script>

<style scoped>
.footer-powered-by {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.cit-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
</style>
